// import rutas from './router.json';
import Cookies from 'js-cookie';
import { Ruta } from '../../types/Types';
import { BackMappings } from '../../utils/BackMappings';
import { AppMappings } from '../../utils/AppMappings';
import { FrontMappings } from '../../utils/FrontMappings';

const LoadRouterByPath = (path: string, lng: string) => {
  let res = '/';
  if (typeof path !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-var-requires,global-require
    const route = require('./router.json');
    const rutaActual = route.rutas.filter(
      (r: Ruta) => r.value.toLowerCase() === path.toLowerCase(),
    );
    if (rutaActual.length > 0) {
      const rutaActualLng = route.rutas.filter(
        (r: Ruta) => r.key === rutaActual[0].key,
      );
      const rutaLng = rutaActualLng.filter((r: Ruta) => r.lng === lng);
      if (rutaLng.length > 0) {
        res = `/${rutaLng[0].lng}/${rutaLng[0].value}`;
      } else {
        const rutaDefault = rutaActualLng.filter(
          (r: Ruta) => r.default === true,
        );
        Cookies.set('i18next', rutaDefault[0].lng);
        res = `/${rutaDefault[0].lng}/${rutaDefault[0].value}`;
      }
    } else {
      res = path;
    }
  }
  return res;
};

const LoadRouteAppByPath = (path: string, isCaprabo: boolean) => {
  let hrefApp = AppMappings.ROOT_APP_ERO;
  if (isCaprabo) {
    hrefApp = AppMappings.ROOT_APP_CPB;
  }
  hrefApp = `${hrefApp}/${path}`;
  return hrefApp;
};

const LoadRouteByPathChoosingBetweenAppOrWeb = (
  pathWeb: string,
  pathApp: string,
  lng: string,
  isCaprabo: boolean,
  isApp: boolean,
) => {
  let href = '';
  const hrefApp = LoadRouteAppByPath(pathApp, isCaprabo);
  const hrefWeb = LoadRouterByPath(pathWeb, lng);
  if (isApp) {
    href = hrefApp;
  } else {
    href = hrefWeb;
  }
  return href;
};

const getRutas = (componente: string) => {
  // eslint-disable-next-line @typescript-eslint/no-var-requires,global-require
  const route = require('./router.json');
  const r1 = route.rutas.filter((r: Ruta) => r.key === componente);
  const rutas = r1.map((ru: Ruta) => `/${ru.lng}/${ru.value}`);
  return rutas;
};

const getBackMapping = (frontMapping: string) => {
  let backMapping = '';
  const queryString = window.location.search.substring(1);
  switch (frontMapping) {
    case FrontMappings.MISDATOS:
      backMapping = BackMappings.MISDATOS;
      break;
    case FrontMappings.SALDO:
      backMapping = BackMappings.SALDO;
      break;
    case FrontMappings.VALES:
      backMapping = BackMappings.VALES;
      break;
    case FrontMappings.AHORROS:
      backMapping = BackMappings.AHORROS;
      break;
    case FrontMappings.PUNTOS_TRAVEL:
      backMapping = BackMappings.PUNTOS_TRAVEL;
      break;
    case FrontMappings.COMPRAS:
      backMapping = BackMappings.COMPRAS;
      break;
    case FrontMappings.TARJETA:
      backMapping = BackMappings.TARJETA;
      break;
    case FrontMappings.ORO:
      backMapping = BackMappings.ORO;
      break;
    case FrontMappings.REVISTA:
      backMapping = BackMappings.REVISTA;
      break;
    case FrontMappings.CAMBIO_MAIL:
      backMapping = BackMappings.CAMBIO_MAIL;
      break;
    case FrontMappings.CAMBIO_PASS:
      backMapping = BackMappings.CAMBIO_PASS;
      break;
    case FrontMappings.BAJA_DIGITAL:
      backMapping = BackMappings.BAJA_DIGITAL;
      break;
    case FrontMappings.TARJETAS_BOT:
      backMapping = BackMappings.TARJETAS_BOT;
      break;
    default:
      backMapping = BackMappings.MISDATOS;
  }
  return queryString
    ? backMapping.concat('?').concat(queryString)
    : backMapping;
};

export default {
  LoadRouterByPath,
  LoadRouteByPathChoosingBetweenAppOrWeb,
  getRutas,
  getBackMapping,
};
